import { DefaultComponent } from '@/types/component';
import { pathToComponent, withDebugMetadata } from 'lib/utils';
import component, { componentExists } from 'modules/dynamic-components';
import { StandaloneArticleTeaser } from './Default';

export const standalone = StandaloneArticleTeaser;

const DefaultArticleTeaser: DefaultComponent = ({ type, data, meta, descendants }) => {
  const componentName = 'ContentArticleTeaser' + (pathToComponent(meta.path) || 'Default');

  const ArticleTeaser = componentExists(componentName)
    ? component(componentName)
    : component('ContentArticleTeaserDefault');

  return <ArticleTeaser {...{ type, data, meta, descendants }} {...withDebugMetadata({ type, meta })} />;
};

export default DefaultArticleTeaser;
